import { createContext } from 'react';
import {ID, Response} from '../../../../../_dashboard/helpers'
import { Contact } from '../../../contact-management/contact-details/core/_models';
export interface SocialMedia {

  fbUrl?:string;
  instaUrl?:string;
  tiktokUrl:string
  youtyubeUrl?:string

}

export interface Header {
  _id?: ID;
  description?:string;
  contact?:Contact;
  image:string
  seoUrl?:string
  socialMedia?:SocialMedia

}



export const initialHeader: Header = {


  contact: {
  
    email: '',
    phone: '',
    adress:''
  },
 
  description:'',
  image: '',

};
export type HeaderQueryResponse = Response<Array<Header>>;
export type QueryResponseHeaderContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  refetchData: () => void
  isLoading: boolean
  query: any
}
export function createHeaderResponseContext<T>(initialState: QueryResponseHeaderContextProps<T>) {
  return createContext(initialState)
}
export const initialHeaderQueryResponse = { refetchData: () => { }, isLoading: false, query: '' }